export function stripKeyPrefix(name) {
    const base = (name || '').split('/').pop();
    return base.replace(/^[0-9a-fA-F]{8}_/, '');
}

export function displayNameFromKey(name) {
    const base = (name || '').split('/').pop();
    return base.replace(/^[0-9a-fA-F]{8}_/, '');
}
